import { Chat } from "../../../../common/Chat";
import { ClearButton } from "../../../../common/Components/Buttons/ClearButton";
import { AppUnderlinedTitle } from "../../../../shared/components/AppUnderlinedTitle";
import { useAssistantChat } from "../../hooks/use-assistant-chat";
import { AttachedFileModal } from "../../../Modals/AttachedFileModal";
import { DialoguesSwitcher } from "./DialogueSwitcher";
import { UPLOADED_FILE_EXTENSIONS } from "../../../Modals/AttachedFileModal/constants";
import { useAppModals } from "../../../../app/state/modalSlice/hook/use-app-modals";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { selectAssistantMeta, selectChatLogs } from "../../redux/selectors";
import styles from "./styles.module.css";
import { AppIconButton } from "../../../../shared/components/AppIconButton";
import { EyeIcon } from "../../../../shared/icons/EyeIcon";
import { useState } from "react";
import { EyeInvisibleIcon } from "../../../../shared/icons/EyeInvisibleIcon";
import { ChatLogs } from "./ChatLogs";
import { AppSwitch } from "../../../../shared/components/AppSwitch";
import { useTranslation } from "react-i18next";

interface Props {
  className?: string;
}

export const AssistantChat = ({ className }: Props) => {
  const {
    messages,
    message,
    fileName,
    selectedId,
    messageLoadingInfo,
    isFileLoading,
    inputRef,
    handleClick,
    handleDeleteFileTag,
    handleFileUpload,
    handleClearChat,
    handleChangeMessage,
    handleSendKeyDown,
    handleSendMessage,
  } = useAssistantChat();
  const meta = useAppSelector(selectAssistantMeta);
  const chatLogs = useAppSelector(selectChatLogs);
  const { handleOpenModal, handleCloseModal } = useAppModals();
  const [openLogs, setOpenLogs] = useState<boolean>(false);
  const { t } = useTranslation();

  return (
    <div className={styles["assistant-chat"]}>
      <AppUnderlinedTitle
        leftContent={<DialoguesSwitcher />}
        className={styles["assistant-chat-header"]}
      >
        <div className={styles["actions-container"]}>
          <div className={styles["open-logs"]}>
            <span>{t("agents.logs_mode")}</span>
            <AppSwitch
              value={openLogs}
              onChange={() => setOpenLogs(!openLogs)}
            />
          </div>
          <ClearButton
            typeBtn={"text_btn"}
            iconType={"broom"}
            onClick={handleClearChat}
            isDisabled={messageLoadingInfo[selectedId as string]}
          />
        </div>
      </AppUnderlinedTitle>
      <Chat
        inputRef={inputRef}
        messages={messages}
        userMessage={message}
        fileName={fileName ?? ""}
        onChangeUserMessage={handleChangeMessage}
        handleSendMessage={handleSendMessage}
        handleKeyDownMessage={handleSendKeyDown}
        handleFileUpload={handleFileUpload}
        handleOpenAttachedFileModal={handleOpenModal}
        isMessageLoading={messageLoadingInfo[selectedId as string] ?? false}
        isFileLoading={isFileLoading}
        onDeleteFilaTag={handleDeleteFileTag}
        loadingMessage={chatLogs[selectedId as string] ?? ""}
        isResizable
      />

      <AttachedFileModal
        extensions={UPLOADED_FILE_EXTENSIONS}
        onClose={handleCloseModal}
        handleClick={handleClick}
        multiple={false}
      />
      {openLogs && <ChatLogs />}
    </div>
  );
};
